import styled from 'styled-components';

import { TextWithLangLinks } from 'components/text-with-lang-links';

import { TermsLink as BaseTermsLink } from './styled.base';

export * from './styled.base';

export const TermsLink = styled(BaseTermsLink)`
  font-weight: ${Styles.fontWeight.normal};
`;

export const StyledTextWithLangLinks = styled(TextWithLangLinks)`
  display: block;
`;
